import React from "react";
import { ButtonIcon } from "@loanbossinc/component-library";
import styled from "styled-components";

const CellWrapper = styled.div`
    padding: 1em;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #DADCE0;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
`;

const PresetName = styled.div`
    cursor: pointer;
`;

const ButtonsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const PresetsDrawerCell = ({ presetName, onPresetClicked, onEditButtonClicked, onDeletePresetClicked }) => (
  <CellWrapper>
    <PresetName onClick={onPresetClicked}>{presetName}</PresetName>
    <ButtonsWrapper>
      <ButtonIcon iconName="edit" onClick={onEditButtonClicked} />
      <ButtonIcon iconName="delete" style={{ color: "#C40A0A" }} onClick={onDeletePresetClicked} />
    </ButtonsWrapper>
  </CellWrapper>
);

export default PresetsDrawerCell;
